/* Shared wallet-card themes — single source of truth pre 3 miesta:
 *   - Settings color picker (Nastavenia.jsx)
 *   - SidebarAccountSwitcher (desktop)
 *   - MobileAccountSwitcher (mobile pocket)
 *
 * Pridanie novej farby = pridaj kľúč sem + spravidla aktualizuj DEFAULT.
 * Custom hex farby idú cez resolveCardTheme priamo (žiadny enum).
 */

// c1 = base (brand color), c2 = darker gradient end (hexDarken ~0.44 z c1).
// Brand farby z CLAUDE.md: blue #4ca7f2 / yellow #f2b01c / green #37b758 / red #f24c4c.
// Ink je neutralny default keď user nemá nastavenú farbu firmy.
export const CARD_THEMES = {
  green:  { c1: '#37b758', c2: '#1f6631', title: 'Zelená' },
  blue:   { c1: '#4ca7f2', c2: '#2b5e88', title: 'Modrá' },
  yellow: { c1: '#f2b01c', c2: '#886310', title: 'Žltá' },
  red:    { c1: '#f24c4c', c2: '#882b2b', title: 'Červená' },
  ink:    { c1: '#2a3a5f', c2: '#0e1730', title: 'Atramentová' },
};

// Default keď workspace.settings.card_color je undefined. Atramentová pôsobí
// neutrálne a koresponduje s defaultnou "tmavou kreditkou" v Settings preview.
export const DEFAULT_CARD_COLOR = 'ink';

// Rotácia keď user neurčil farbu — i-ta firma dostane i-tu farbu z palety.
// Drží farebnú postupnosť konzistentnú medzi wallet pocket (sidebar/mobile)
// a peek kartami v Nastaveniach.
export const THEME_ROTATION = ['green', 'blue', 'yellow', 'red', 'ink'];

export function cardThemeByIndex(i) {
  return CARD_THEMES[THEME_ROTATION[((i % THEME_ROTATION.length) + THEME_ROTATION.length) % THEME_ROTATION.length]];
}

export function hexDarken(hex, factor) {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return hex;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const m = (v) => Math.round(v * (1 - factor));
  return '#' + [m(r), m(g), m(b)].map((v) => v.toString(16).padStart(2, '0')).join('');
}

export function resolveCardTheme(cardColor, index) {
  // Custom hex
  if (cardColor && /^#[0-9a-f]{6}$/i.test(cardColor)) {
    return { c1: cardColor, c2: hexDarken(cardColor, 0.55) };
  }
  // Named theme (enum)
  if (cardColor && CARD_THEMES[cardColor]) return CARD_THEMES[cardColor];
  // No explicit color — rotate cez paletu ak je daný index, inak default 'ink'.
  if (index !== undefined && index !== null) return cardThemeByIndex(index);
  return CARD_THEMES[DEFAULT_CARD_COLOR];
}
